import { render } from "./DialogColor.vue?vue&type=template&id=d23be12c"
import script from "./DialogColor.vue?vue&type=script&lang=js"
export * from "./DialogColor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__